import { ChangeDetectionStrategy, Component, forwardRef, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectableAddress } from '@ipensii/shared/domain-shared';

@Component({
  selector: 'ip-shared-address-part-selection',
  standalone: true,
  imports: [CommonModule, DropdownModule, FormsModule],
  templateUrl: 'address-part-selection.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AddressPartSelectionComponent), multi: true },
  ],
})
export class AddressPartSelectionComponent implements ControlValueAccessor {
  @Input() resources: Array<SelectableAddress> = [];
  @Input() placeholder = 'Selectează o țară';
  @Input() optionLabel = 'name';
  @Input() required = false;
  @Input() disabled = false;
  @Input() property: keyof SelectableAddress = 'name';
  selectedResource: string | undefined;
  @ViewChild('dropdown') private readonly dropdown!: Dropdown;

  private onTouch!: (_: string) => void;
  private onChange!: (_: string) => void;

  registerOnChange(fn: (_: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: (_: string) => void): void {
    this.onTouch = fn;
  }

  writeValue(obj: string): void {
    this.selectedResource = obj;
    this.onChange && this.onChange(obj);
  }

  onHide() {
    const options: Array<SelectableAddress> = this.dropdown.visibleOptions();
    if (options.length === 1) {
      this.writeValue(options[0][this.property]);
    }
  }
}
